import React from "react"

const Loading = (props) => {
	return (
		props.show ?
			<div className="loading">
				<div className="lds-ring">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div> : ""
	)
}

export default Loading
